<p-table [value]="usageArray" [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template pTemplate="header">
    <tr>
      <th>Tag</th>
      <th>Input Tokens</th>
      <th>Output Tokens</th>
      <th>Total Tokens</th>
      <th>API Calls</th>
      <th>Input Cost</th>
      <th>Output Cost</th>
      <th>Total Cost</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr>
      <td>{{ item.tag }}</td>
      <td>{{ item.tokenUsage.input }}</td>
      <td>{{ item.tokenUsage.output }}</td>
      <td>{{ item.tokenUsage.total }}</td>
      <td>{{ item.apiCalls }}</td>
      <td>{{ item.inputCost | number : '1.4-4' }}</td>
      <td>{{ item.outputCost | number : '1.4-4' }}</td>
      <td>{{ item.totalCost | number : '1.4-4' }}</td>
    </tr>
  </ng-template>
</p-table>
